export default __webpack_public_path__ + "static/media/CW__3111.b3f65565.jpg";